module.exports = __webpack_public_path__ + "img/Chat.3157246a.svg";